export default __webpack_public_path__ + "static/media/logo.b5cf1392.png";